import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "dateDebut",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Date Debut"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "dateFin",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Date Fin"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "statut",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Statut"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Document "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black mb-10" }, [
  /*#__PURE__*/_createTextVNode(" User "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_17 = { class: "col-md-12 d-flex flex-column mt-3" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-success me-3",
  type: "submit"
}, " Modifier Emprunt ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "empruntForm",
        onSubmit: _ctx.editEmprunt,
        "validation-schema": _ctx.empruntSchema,
        "initial-values": _ctx.empruntForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Field, {
                name: "dateDebut",
                class: "form-control",
                type: "number"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "dateDebut",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Field, {
                name: "dateFin",
                class: "form-control",
                type: "number"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "dateFin",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Field, {
                name: "statut",
                class: "form-control",
                type: "text"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "statut",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  name: "document",
                  modelValue: _ctx.documents,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.documents) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.documentOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner le document",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.showMErr)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Le document est obligatoire"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, {
                  name: "user",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.userOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner l'utilisateur",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "user",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_router_link, {
                  to: "/emprunts/liste-emprunt",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _hoisted_21,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}